import React, { Component } from 'react';

const ExampleNavigation = () =>
  <section id="navigation">
    <h3 className="section-header">Navigation</h3>
    <div className="row">
      <div className="columns small-15">
        <h4>Pagination</h4>
        <div className="pagination">
          <div className="hide-for-small-only">
            <a href="#" className="prev"><i className="fa fa-angle-left"></i></a> 
            <a href="#" className="num">1</a> 
            <a href="#" className="num active">2</a> 
            <a href="#" className="num">3</a> 
            <a href="#" className="num">4</a> 
            <a href="#" className="num">5</a>
            <a href="#" className="num last">&hellip;</a> 
            <a href="#" className="next"><i className="fa fa-angle-right"></i></a>
          </div>
          <div className="text-center show-for-small-only">
            <a href="#" className="prev"><i className="fa fa-chevron-circle-left"></i></a>
            <span className="num current">1</span><span className="num total">/15</span>
            <a href="#" className="next"><i className="fa fa-chevron-circle-right"></i></a>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="medium-15 columns">
        <h4>Tabs</h4>
        <div className="tabs">
          <div className="show-for-small-only"><a href="#" className="dropdown-toggle">Tab 1<i className="fa fa-caret-down"></i></a></div>
          <ul className="dropdown">
            <li><a href="#">Tab 1</a></li>
            <li className="active">Tab 2</li>
            <li><a href="#">Tab 3</a></li>
            <li><a href="#">Tab 4</a></li>
          </ul>
        </div>
      </div>
    </div>
  </section>;

export { ExampleNavigation }



// WEBPACK FOOTER //
// ./styleguide/components/navigation.jsx